export default "__VITE_ASSET__BjQyIEZG__"